/**
 * プロジェクトの名前の変更の英語の文言（2026-09-28 creator/project-rename・AGT-10）。en.ts が `...enProjectName` で取り込む
 * （ja.projectName.ts が同じキーを全部持つことを型で強制）。使う画面: components/ProjectNameCard.tsx（ホスティングの画面の「プロジェクト名」）。
 * error.name_reserved は作成の画面（pages/ProjectsPage.tsx の CreateProject）でも errorText が `error.<code>` として引く = 2 つの口で同じ説明。
 *
 * 言葉はダッシュボード全体の決め事どおり「利用者（users）/ プロジェクト」（i18n/wording.test.ts・プレイヤー / ゲームと書かない）。
 * WHY 説明文で「メールの件名と差出人」と言うか: 名前が一番効くのはプレイヤーに届くメール（件名 "Confirm your email for <名前>"・差出人の表示名）。
 *   仮の名前のまま公開すると、プレイヤーに "test" から確認メールが届く。公開の前に決めてもらうため、どこに出るかを具体的に書く。
 *   URL スラッグは別の値（カードも別）なので、「名前を変えても URL は変わらない」を一言添える（取り違えて両方変える・片方で足りると思う、を防ぐ）。
 * WHY name_reserved を長く書くか: 「予約されています」だけでは何を直せばいいか分からない。理由（運営に見えてプレイヤーを誤解させる）・
 *   当たる例（"Kumo" を含む・"Support" / "Security" だけ）・直し方（プロジェクトそのものの名前 = 例 "Booking App"。2026-09-30 console/words-2 でゲームの例 "Sky Racers" からアプリの例へ = MASTER-PLAN §0）を 1 文ずつ。
 */
export const enProjectName = {
  'projectName.title': 'Project name',
  'projectName.lead':
    'Your users see this name in the subject line and sender name of the emails they receive, so pick a clear name before you launch. The name in your web address (the “neko-jump” kind of part) is a separate setting: changing this name does not change your web address.',
  'projectName.label': 'Name',
  'projectName.count': '{count}/{max}',
  'projectName.tooLong': 'Use {max} characters or fewer.',
  'projectName.save': 'Save',
  'projectName.saving': 'Saving…',
  'projectName.renamed': 'Renamed from “{old}” to “{new}”.',
  'projectName.unchanged': 'The name is already “{name}” — nothing changed.',
  'projectName.error.rateLimited': 'Too many name changes — you can change it up to 20 times an hour. Try again later.',
  'projectName.error.accountClosed': 'This account is closed, so the project name cannot be changed.',
  'projectName.error.invalid': 'The name must be 1–{max} characters.',
  'projectName.error.generic': 'Could not change the name. Wait a moment and try again.',

  // サーバーのエラー（errorText が `error.<code>` を引く・作成の画面でも同じ文言）
  'error.name_reserved':
    'That name looks like {product} or its staff, which could mislead your users when it appears in their emails. Names that contain the word “KUMO”, or that are only words like “Support” or “Security”, can’t be used. Choose a name for your project itself, such as “Booking App”.'
} satisfies Record<string, string>;
